import { render, staticRenderFns } from "./ObjectMapping.vue?vue&type=template&id=459ff5bc&scoped=true&"
import script from "./ObjectMapping.vue?vue&type=script&lang=js&"
export * from "./ObjectMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459ff5bc",
  null
  
)

export default component.exports